import React, {useMemo} from 'react';
import cx from 'classnames';

import {trans} from "../../../../common/utils";
import {WithDropdown} from '../../../../components';


const BranchPicker = (
    {mountedBranch, siteStatus, language, viewSize}
) => {
    const branchPickerConfig = useMemo(() => [
        {
            label: 'All',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/1',
                'data-branch-id': 1,
            },
            element: <>{trans('All')}</>,
        },
        {
            label: 'Today',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/2',
                'data-branch-id': 2,
            },
            element: <>{trans('Today')}</>,
        },
        {
            label: '1 Hour',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/3',
                'data-branch-id': 3,
            },
            element: <>{trans('1 Hour')}</>,
        },
        {
            label: '3 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/4',
                'data-branch-id': 4,
            },
            element: <>{trans('3 Hours')}</>,
        },
        {
            label: '6 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/5',
                'data-branch-id': 5,
            },
            element: <>{trans('6 Hours')}</>,
        },
        {
            label: '12 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/6',
                'data-branch-id': 6,
            },
            element: <>{trans('12 Hours')}</>,
        },
        {
            label: '24 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/7',
                'data-branch-id': 7,
            },
            element: <>{trans('24 Hours')}</>,
        },
        {
            label: '48 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/8',
                'data-branch-id': 8,
            },
            element: <>{trans('48 Hours')}</>,
        },
        {
            label: '72 Hours',
            elementAttributes: {
                as: 'NavLink',
                to: '/sport/9',
                'data-branch-id': 9,
            },
            element: <>{trans('72 Hours')}</>,
        },
    ], [language]);

    return (
        <div className={cx('branch-picker', `branch-picker--${viewSize}`)}>
            <WithDropdown
                dataSource={{ submenu: branchPickerConfig }}
                openBehavior="click"
                menuItemIsActive={(branch) => branch.label === mountedBranch}
                customClasses={`ll-branch-picker__dropdown-wrapper--${viewSize}${
                    mountedBranch !== 'All'
                        ? ' ll-branch-picker__dropdown-wrapper--accent'
                        : ''
                }`}
                onMenuItemClick={() => siteStatus.setBackdropShown(false)}
                menuClasses="ll-branch-picker__dropdown"
                delay={500}
                placement="bottom-end"
            >
                <span
                    onClick={() => {
                        siteStatus.setBackDropFullScreen(false);
                        siteStatus.setBackdropShown(true);
                    }}
                >
                    {trans('Filter time')}: {trans(mountedBranch)}
                </span>
            </WithDropdown>
        </div>
    );
};

export default BranchPicker;

